<ng-container *ngIf="(league$ | async)?.entry as league">
    <ng-container *ngIf="league.state === 'finished'">
        <league-winner
            *ngIf="contestant$ | async as contestant"
            [image]="contestant.user?.photo || contestant.team?.logo"
            [leagueName]="league.name.full"
            [contestantName]="contestant.user?.nickname || contestant.team?.name"
            [hasTrusted]="contestant.user?.trustLevel > 0 || contestant.team?.trustLevel > 0"
            [hasPremium]="contestant.user?.premium || contestant.team?.premium"
        ></league-winner>
    </ng-container>
</ng-container>
